






import Vue from 'vue';
import Component from 'vue-class-component';
import { DataSourceTemplate } from '@/models/data/models';

@Component({})
export default class DataSourceTemplateList extends Vue {
  DataSourceTemplate = DataSourceTemplate;
  get filter() {
    return {
      application: this.$store.getters['global/application']
        ? this.$store.getters['global/application'].id
        : 'unknown', // explicitly set to 'unknown' to not show anything
    };
  }
}
